import { t } from "@bookingcom/lingojs-react";
import { pricingUtils } from "@flights/web-api-utils-universal";
export function convertFlightToFare(flight, i18n) {
    const features = flight.brandedFareInfo?.features || [];
    return {
        brandedFareInfo: {
            fareName: i18n.trans(t("flights_apex_sr_standard_ticket")),
            features,
            featuresList: flight.brandedFareInfo?.featuresList || []
        },
        token: flight.token,
        offerReference: flight.offerReference || flight.token,
        priceBreakdown: flight.priceBreakdown,
        travellerPrices: flight.travellerPrices,
        includedProducts: flight.includedProducts,
        includedProductsBySegment: flight.includedProductsBySegment
    };
}
export function getBrandedFarePriceMismatchMetricName(baseOfferPrice, brandedFarePrice, carriers, pointOfSale, grumble) {
    const baseOfferPriceValue = pricingUtils.priceToValue(baseOfferPrice);
    const brandedFarePriceValue = pricingUtils.priceToValue(brandedFarePrice);
    const difference = (brandedFarePriceValue - baseOfferPriceValue) / baseOfferPriceValue;
    if (difference === 0) {
        return "branded_fares_on_search_results_first_bf_price_is_equal";
    }
    else if (difference < -0.05) {
        grumble?.("First branded fare price is lower than base offer price", {
            base_offer_price: baseOfferPriceValue,
            branded_fare_price: brandedFarePriceValue,
            pointOfSale: pointOfSale,
            carriers
        });
        return "branded_fares_on_search_results_first_bf_price_is_lower_difference_gt_5_percent";
    }
    else if (difference < 0) {
        return "branded_fares_on_search_results_first_bf_price_is_lower_difference_lte_5_percent";
    }
    else if (difference > 0.05) {
        grumble?.("First branded fare price is higher than base offer price", {
            base_offer_price: baseOfferPriceValue,
            branded_fare_price: brandedFarePriceValue,
            pointOfSale: pointOfSale,
            carriers
        });
        return "branded_fares_on_search_results_first_bf_price_is_higher_difference_gt_5_percent";
    }
    else {
        return "branded_fares_on_search_results_first_bf_price_is_higher_difference_lte_5_percent";
    }
}
